import { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { postApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";
import toast from "react-hot-toast";

const useOtpSubscription = (otpLength = 6) => {
  const [otp, setOtp] = useState("");
  const inputRefs = useRef(new Array(otpLength).fill(null));
  const { state } = useLocation();
  const navigate = useNavigate();

  const focusInput = (index) => {
    inputRefs.current[index]?.focus();
  };

  const selectInput = (index) => {
    inputRefs.current[index]?.select();
  };

  const handleKeyDown = (e, index) => {
    switch (e.key) {
      case "ArrowUp":
      case "ArrowDown":
      case " ":
        e.preventDefault();
        break;
      case "ArrowLeft":
        e.preventDefault();
        if (index > 0) {
          focusInput(index - 1);
          selectInput(index - 1);
        }
        break;
      case "ArrowRight":
        e.preventDefault();
        if (index < otpLength - 1) {
          focusInput(index + 1);
          selectInput(index + 1);
        }
        break;
      case "Delete":
      case "Backspace":
        e.preventDefault();
        if (e.key === "Backspace" && index > 0) {
          focusInput(index - 1);
          selectInput(index - 1);
        }
        setOtp((prev) => {
          const otpArray = prev.split("");
          otpArray[index] = "";
          return otpArray.join("");
        });
        break;
      default:
        break;
    }
  };

  const handleChange = (e, index) => {
    const val = e.target.value;
    let nextIndex = index;

    while (nextIndex <= index) {
      if (inputRefs.current[nextIndex].value && nextIndex < index) {
        nextIndex++;
      } else break;
    }

    setOtp((prev) => {
      const otpArray = prev.split("");
      otpArray[nextIndex] = val.slice(-1);
      return otpArray.join("");
    });

    if (val !== "" && index < otpLength - 1) {
      focusInput(index + 1);
    }
  };

  const handlePaste = (e, index) => {
    e.preventDefault();
    let pastedText = e.clipboardData.getData("text/plain").trim().slice(0, otpLength);
    const otpArray = otp.split("");

    for (let i = index; i < otpLength; i++) {
      otpArray[i] = pastedText[i - index] ?? "";
    }
    setOtp(otpArray.join(""));
  };

  const handleClick = (e, index) => {
    selectInput(index);
  };

  const onSubmit = async () => {
    const obj = {
      first_name: state?.data?.first_name,
      last_name: state?.data?.last_name,
      email: state?.data?.email,
      contact_number: state?.data?.contact_number,
      otp,
    };

    try {
      const res = await postApi(apiEndPoints.verifyNewsLetter, obj);
      if (res?.data?.status === 0) {
        toast.error(res?.data?.message);
      } else if (res?.data?.status === 1) {
        toast.success(res?.data?.message);
        navigate("/newsLettersuccess", { state: { obj } });
      } else {
        toast.error("Something went wrong");
      }
    } catch (err) {
      toast.error(`Registration failed: ${err}`);
    }
  };

  return {
    otp,
    setOtp,
    inputRefs,
    focusInput,
    selectInput,
    handleKeyDown,
    handleChange,
    handlePaste,
    handleClick,
    onSubmit,
    state,
  };
};

export default useOtpSubscription;
